// pages/TopMarketCap.js
import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';
import FilterNav from './FilterNav';

const apiUrl = process.env.REACT_APP_API_URL;

const TopMarketCap = ({ currentPage, setCurrentPage, totalPages, setTotalPages, loading, setLoading }) => {
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTopMarketCap = async () => {
      setLoading(true);
      const query = new URLSearchParams({ page_number: currentPage }).toString();
      try {
        const response = await fetch(`${apiUrl}/api/coins/top-market-cap?${query}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const data = await response.json();
        setCoins(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching top market cap coins:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopMarketCap();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    console.log(direction);
    setCurrentPage((prevPage) => {
      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1); // Minimum page is 1
      } else if (direction === 'next') {
        return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prevPage;
    });
  };

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
      <div className="home_wrapper">
        <HomeFilter coins={coins} />
        <div className="btn_mainsec">
          <button
            className="btn_style"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <button
            className="btn_style"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
  );
};

export default TopMarketCap;